export const defaultTableConfig = {
  page: 1,
  limit: 10,
  sort_order: undefined,
  sort_by: undefined,
  filter: undefined,
};

export const defaultPaginationConfig = {
  page: 1,
  limit: 10,
};

export const validityTypes = [
  {
    key: 'days',
    label: 'Day(s)',
    value: 'days',
  },
  {
    key: 'months',
    label: 'Month(s) (30 days)',
    value: 'months',
  },
  {
    key: 'years',
    label: 'Year(s) (365 days)',
    value: 'years',
  },
];
